import { GQLForeignRootQuery } from '../gql/__generated__/ForeignRoot'
import { GQLPhotoItemFragment } from '../gql/__generated__/Photos'

/** Можно попробовать сделать через sort, только надо покрыть тестами. */
export const mergePhotos = (
  user: GQLForeignRootQuery['user']
): GQLPhotoItemFragment[] => {
  if (user) {
    if (user.photos.default && user.photos.photos.nodes.length > 0) {
      const photos = user.photos.photos.nodes.filter(
        ({ photoId }) => photoId !== user.photos.default!.photoId
      )

      return [user.photos.default, ...photos]
    } else if (user.photos.default) {
      return [user.photos.default]
    } else if (user.photos.photos.nodes.length > 0) {
      return [...user.photos.photos.nodes]
    } else {
      return []
    }
  }

  return []
}
